import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const dropdownPlantLevelConfigSlice = createApi(`DropdownPlantLevelConfigSlice`,"GET");

const DropdownPlantLevelConfigSlice = createSlice({
  name: 'DropdownPlantLevelConfigSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dropdownPlantLevelConfigSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dropdownPlantLevelConfigSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(dropdownPlantLevelConfigSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DropdownPlantLevelConfigSlice.reducer;